<div autofocus tabindex="0" id="menu-profile-container">
    <div [hidden]="isSwitchGroupDisplayed" (keyup.escape)="close()" trapFocus>
        <ng-container [ngTemplateOutlet]="menuProfile"> </ng-container>
    </div>
    <div [hidden]="!isSwitchGroupDisplayed" class="switch-group-overlay">
        <ng-container [ngTemplateOutlet]="menuGroup"></ng-container>
    </div>
</div>

<ng-template #menuGroup>
    <app-menu-group [displayBackButton]="true" (closePopover)="toggleMenuGroupOverlay(false)"></app-menu-group>
</ng-template>

<ng-template #menuProfile>
    <ul id="menu-profile">
        <li [hidden]="true" id="user-group-item">
            <button id="user-group" (click)="toggleMenuGroupOverlay(true)">
                <div>
                    <div class="btn-icon" id="user-group-icon">
                        <i class="fa-thin fa-users"></i>
                    </div>
                    <label for="user-group-icon" id="user-group-label">
                        <span>{{ 'group' | translate }}:</span>
                        UX Team
                    </label>
                </div>
                <i class="fa-thin fa-angle-right" id="open-switch-group-popover-btn"></i>
            </button>
        </li>
        <li [hidden]="true" id="account-settings-item">
            <button id="account-settings">
                <div class="btn-icon" id="account-settings-icon">
                    <i class="fa-thin fa-user-gear"></i>
                </div>
                <label for="account-settings-icon" id="account-settings-label">{{
                    'profileMenu.accountSettings' | translate
                }}</label>
            </button>
        </li>
        <li [hidden]="true" id="billing-settings-item">
            <button id="billing-settings">
                <div class="btn-icon" id="billing-settings-icon">
                    <i class="fa-thin fa-file-invoice-dollar"></i>
                </div>
                <label for="billing-settings-icon" id="billing-settings-label">{{
                    'profileMenu.billingSettings' | translate
                }}</label>
            </button>
        </li>
        <li [hidden]="true" id="message-settings-item">
            <button id="message-settings">
                <div class="btn-icon" id="message-settings-icon">
                    <i class="fa-thin fa-message-lines"></i>
                </div>
                <label for="message-settings-icon" id="message-settings-label">{{
                    'profileMenu.messageSettings' | translate
                }}</label>
            </button>
        </li>
        <li [hidden]="true" id="administration-item">
            <button id="administration-link">
                <div class="btn-icon" id="administration-icon">
                    <i class="fa-thin fa-folder-gear"></i>
                </div>
                <label for="administration-icon" id="administration-label">{{
                    'profileMenu.administration' | translate
                }}</label>
            </button>
        </li>
        <li id="sign-out-item">
            <button id="sign-out-link" (click)="logout()">
                <div class="btn-icon" id="sign-out-icon">
                    <i class="fa-thin fa-right-from-bracket"></i>
                </div>
                <label for="sign-out-icon" id="sign-out-label">{{ 'profileMenu.signOut' | translate }}</label>
            </button>
        </li>
    </ul>
</ng-template>
